module.exports = __webpack_public_path__ + "img/minimize-2.f89a7ff3.svg";